<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type="false" ref="head_page"></head_page>
      </el-header>

      <el-main>
        <div id="choose_city" style="backgroundcolor: white">
          <head_menu :has-back="true" @go-back-click="goBack"> </head_menu>
        </div>
        <div>
          <!-- 新增外部用户按钮（已恢复） -->
          <el-button
            type="warning"
            plain
            size="small"
            round
            style="margin: 5px"
            @click="clickAddExternalUser()"
            >{{ $t("message.add_external_user") }}</el-button
          >
          <!-- 公司管理按钮 -->
          <el-button
            type="success"
            plain
            size="small"
            round
            style="margin: 5px"
            @click="clickCompanyManagement()"
            >公司管理</el-button
          >
          <el-table
            :data="user_list"
            height="800"
            border
            style="width: 100%"
            v-loading="userTableLoading"
            @filter-change="filterChange"
          >
            <el-table-column
              prop="name"
              :label="$t('message.name')"
              width="180"
            >
              <template slot-scope="scope" slot="header">
                <span :class="{ highlight: nameKeywordHighlight }">{{
                  $t("message.name")
                }}</span>
                <span class="el-table__column-filter-trigger"></span>
                <el-popover
                  placement="bottom"
                  trigger="click"
                  transition="el-zoom-in-top"
                  visible-arrow="false"
                  style="padding: 0"
                  ref="nameKeyword"
                >
                  <div class="user-table-filter">
                    <div class="user-table-filter__content">
                      <div class="sub-title">
                        {{ $t("message.Search_creator") }}
                      </div>
                      <input
                        class="search-input"
                        :placeholder="$t('message.Please_enter_keyword')"
                        v-model="nameKeyword"
                      />
                    </div>
                    <div class="user-table-filter__bottom">
                      <button
                        @click="nameFilterHandler"
                        :class="{ 'is-disabled': nameKeyword.length === 0 }"
                        :disabled="nameKeyword.length === 0"
                      >
                        {{ $t("message.Filter") }}
                      </button>
                      <button @click="nameResetHandler">
                        {{ $t("message.Reset") }}
                      </button>
                    </div>
                  </div>
                  <span style="cursor: pointer" slot="reference">
                    <i
                      class="el-icon-arrow-down"
                      style="transform: scale(0.75)"
                    ></i>
                    <!--@click="nameKeywordVisible = !nameKeywordVisible"-->
                  </span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column prop="company" label="公司" width="180">
              <template slot-scope="scope" slot="header">
                <span :class="{ highlight: companyArrayHighlight }">
                  公司
                </span>
                <span class="el-table__column-filter-trigger"></span>
                <el-popover
                  placement="bottom"
                  trigger="click"
                  transition="el-zoom-in-top"
                  visible-arrow="false"
                  style="padding: 0"
                  ref="companyArray"
                >
                  <div class="user-table-filter">
                    <div class="user-table-filter__content">
                      <el-checkbox-group
                        v-model="companyArray"
                        style="margin-top: 5px"
                      >
                        <el-checkbox
                          v-for="option in company_options"
                          :label="option.id"
                          :key="option.id"
                          >{{ option.company_name_cn || option.company_name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                    <div class="user-table-filter__bottom">
                      <button
                        @click="companyFilterHandler"
                        :class="{ 'is-disabled': companyArray.length === 0 }"
                        :disabled="companyArray.length === 0"
                      >
                        {{ $t("message.Filter") }}
                      </button>
                      <button @click="companyResetHandler">
                        {{ $t("message.Reset") }}
                      </button>
                    </div>
                  </div>
                  <span style="cursor: pointer" slot="reference"
                    ><i
                      class="el-icon-arrow-down"
                      style="transform: scale(0.75)"
                    ></i
                  ></span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              prop="role"
              :label="$t('message.role')"
              width="140"
            >
            </el-table-column>
            <el-table-column fixed="right" :label="$t('message.operation')">
              <template slot-scope="scope">
                <el-button type="text" @click="clickEdit(scope.row.email)">{{
                  $t("message.Edit")
                }}</el-button>
                <el-button type="text" @click="clickRemove(scope.row.email)">{{
                  $t("message.Remove")
                }}</el-button>
                <el-button
                  v-if="scope.row.is_external"
                  type="text"
                  @click="toggleExternalUserStatus(scope.row.email, scope.row.active)"
                >{{ scope.row.active ? $t('message.disable_user') : $t('message.enable_user') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize"
          >
          </el-pagination>
        </div>
      </el-main>
      <el-dialog
        :title="$t('message.add_external_user')"
        :visible.sync="addDialogAddFormVisible"
        v-loading="dialogFormLoading"
        @opened="changeAddDiagTransferBoxColor"
        width=68%
      >
      <el-form :model="form_add_external" :rules="rules_external" ref="form_external">
          <el-form-item
            :label="$t('message.Email')"
            :label-width="formLabelWidth"
            prop="email"
          >
            <el-input v-model="form_add_external.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.company')"
            :label-width="formLabelWidth"
            prop="company_id"
          >
            <el-select v-model="form_add_external.company_id" :placeholder="$t('message.company')">
              <el-option
                v-for="item in company_options"
                :key="item.id"
                :label="item.company_name_cn || item.company_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('message.initial_password')"
            :label-width="formLabelWidth"
            prop="password"
          >
            <el-input v-model="form_add_external.password" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.authority')"
            :label-width="formLabelWidth"
          >
          <el-col :span="2"><el-popover placement="top-start" trigger="hover">
              <pre>
浏览城市：访问城市数据
浏览套装列表：浏览套装创建的历史记录
浏览统计数据：访问统计页面
创建套装：创建套装
管理员：所属BU的用户管理权限
分享方案：将自己创建的方案分享给指定用户
接收方案：接收并查看他人分享的方案
</pre>
              <el-button
                icon="el-icon-info"
                circle
                slot="reference"
                style="border: 0px; background-color: #f6f6f6"
              ></el-button>
            </el-popover>
            </el-col>
            <el-col :span="20">
              <el-transfer
                  v-model="form_add_external.no_authority"
                  :data="authority_options"
                  :titles="[$t('message.selected'), $t('message.unselected')]"
                  :props="{
                    key: 'id',
                    label: 'name',
                  }"
                  id="add_diag_transfer"
                  style="text-align: left"
                ></el-transfer>
            </el-col>
          </el-form-item>

          <el-form-item
            :label="$t('message.allowed_discount')"
            :label-width="formLabelWidth"
          >
            <el-col :span="2"><el-popover placement="top-start" trigger="hover">
              <pre>
外部用户的折扣权限设置。
折扣率：允许该外部用户创建的方案中应用的最低折扣。
例如：设置为 80，则该外部用户创建的方案折扣率可以在 80-100 之间。
              </pre>
              <el-button
                icon="el-icon-info"
                circle
                slot="reference"
                style="border: 0px; background-color: #f6f6f6"
              ></el-button>
            </el-popover></el-col>
            <el-input-number
              v-model="form_add_external.discount_rate"
              :min="1"
              :max="100"
            ></el-input-number><b>%</b>
          </el-form-item>

          <el-form-item
            :label="$t('message.city_and_vendor')"
            :label-width="formLabelWidth"
          >
              <el-cascader v-model="form_add_external.city_vendor"
              :options="city_vendor_options"
              :props="{
                    value: 'code',
                    label: 'name',
                    multiple : true,
                  }"
              >
              </el-cascader>
          </el-form-item>
           
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogAddFormVisible = false">{{
            $t("message.Cancel")
          }}</el-button>
          <el-button type="primary" @click="addExternalConfirm()">{{
            $t("message.Confirm")
          }}</el-button>
        </div>
    </el-dialog>

      <el-dialog
        :title="$t('message.edit_user')"
        :visible.sync="editDialogFormVisible"
        v-loading="dialogFormLoading"
        @opened="changeEditDiagTransferBoxColor"
        width=68%
      >
        <div style="text-align: right; font-size: 12px; margin-top: -20px; margin-bottom: 20px;"
          v-if="updated_by && updated_at">
          <div v-if="lang=='en'">
            Last updated by {{updated_by}} at {{updated_at.split(".")[0]}}
          </div>
          <div v-else>
            最后编辑由 {{updated_by}} 于 {{updated_at.split(".")[0]}}
          </div>
        </div>
        <el-form :model="form_edit">
          <el-form-item
            :label="$t('message.Email')"
            :label-width="formLabelWidth"
          >
            <el-input
              v-model="form_edit.email"
              autocomplete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('message.name')"
            :label-width="formLabelWidth"
          >
            <el-input v-model="form_edit.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-if="!form_edit.is_external" :label="$t('message.BU')" :label-width="formLabelWidth">
              <el-select v-model="form_edit.bu">
                  <el-option
                      v-for="item in bu_options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item v-if="form_edit.is_external" label="公司" :label-width="formLabelWidth">
              <el-select v-model="form_edit.company_id">
                  <el-option
                      v-for="item in company_options"
                      :key="item.id"
                      :label="item.company_name_cn || item.company_name"
                      :value="item.id"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item v-if="!form_edit.is_external"
              :label="$t('message.role')"
              :label-width="formLabelWidth"
          >
              <el-select v-model="form_edit.role">
              <el-option
                v-for="item in role_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="!form_edit.is_external"
            :label="$t('message.report_to')"
            :label-width="formLabelWidth"
          >
            <el-select v-model="form_edit.report_to" multiple filterable>
              <el-option
                v-for="item in report_to_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('message.allowed_discount')"
            :label-width="formLabelWidth"
          >
           <el-col :span="2"><el-popover placement="top-start" trigger="hover">
              <pre>
销售人员可以提供的最低折扣权限。
案例1：100%表示该销售无任何折扣权限。
案例2：70%表示该销售最低可以对方案进行7折定价。
</pre>
              <el-button
                icon="el-icon-info"
                circle
                slot="reference"
                style="border: 0px; background-color: #f6f6f6"
              ></el-button>
            </el-popover>

            <el-button
              icon="el-icon-info"
              circle
              slot="reference"
              style="border: 0px; background-color: #f6f6f6"
            ></el-button>
            </el-col>
            <el-input-number
              v-model="form_edit.discount_rate"
              :min="1"
              :max="100"
            ></el-input-number><b>%</b>
          </el-form-item>
          <el-row>
          <el-form-item
            :label="$t('message.authority')"
            :label-width="formLabelWidth"
          >
          <el-col :span="2"><el-popover placement="top-start" trigger="hover">
              <pre>
浏览城市：访问城市数据
浏览套装列表：浏览套装创建的历史记录
浏览统计数据：访问统计页面
创建套装：创建套装
管理员：所属BU的用户管理权限
分享方案：将自己创建的方案分享给指定用户
接收方案：接收并查看他人分享的方案
</pre>
              <el-button
                icon="el-icon-info"
                circle
                slot="reference"
                style="border: 0px; background-color: #f6f6f6"
              ></el-button>
            </el-popover>

            <el-button
              icon="el-icon-info"
              circle
              slot="reference"
              style="border: 0px; background-color: #f6f6f6"
            ></el-button>
            </el-col>
            <el-col :span="20">
              <div class="edit_dev">
                <el-transfer
                  v-model="form_edit.no_authority"
                  :data="authority_options"
                  :titles="[$t('message.selected'), $t('message.unselected')]"
                  :props="{
                    key: 'id',
                    label: 'name',
                  }"
                  id="edit_diag_transfer"
                  style="text-align: left"
                ></el-transfer>
            </div>
            </el-col>
          </el-form-item>
          <el-form-item
            :label="$t('message.Can_crosscity')"
            :label-width="formLabelWidth"
          >
          <el-radio-group v-model="canCreateCrossCity" style="float: left !important; margin-left: 10px;" >
        <el-radio label="Yes" border >Yes</el-radio>
        <el-radio label="No" border >No</el-radio>
      </el-radio-group>
          </el-form-item>
          </el-row>
          <el-form-item
            :label="$t('message.city_and_vendor')"
            :label-width="formLabelWidth"
          >
              <el-cascader v-model="form_edit.city_vendor"
              :options="city_vendor_options"
              :props="{
                    value: 'code',
                    label: 'name',
                    multiple : true,
                  }"
              >
              </el-cascader>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogFormVisible = false">{{
            $t("message.Cancel")
          }}</el-button>
          <el-button type="primary" @click="updateConfirm()">{{
            $t("message.Confirm")
          }}</el-button>
        </div>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import axios from "axios";
import _global from "./components/global.vue";

export default {
  name: "usermangement",
  data() {
    return {
      chosen_city: "Global",
      canCreateCrossCity:'No',
      test_target:100000,
      loading: false,
      lang: "en",
      is_national: false,
      view_nanjing: false,
      view_wuhan: false,
      view_shenzhen: false,
      view_chongqing: false,
      addDialogFormVisible: false,
      addDialogAddFormVisible: false,
      editDialogFormVisible: false,
      editDialogAddFormVisible:false,
      user_list: [],
      bu_options: [],
      role_options: [],
      authority_options: [],
      report_to_options: [],
      form_add: {
        email: "",
        name: "",
        bu: "",
        role: "",
        report_to: [],
        discount_rate: 0,
        authority: [],
        no_authority: [],
        city_vendor:[]
      },
      form_add_external:{
        email: "",
        name: "",
        bu: "",
        company_id: "",
        password: "",
        authority: [],
        no_authority: [],
        city_vendor:[],
        discount_rate: 100
      },
      form_edit: {
        email: "",
        name: "",
        bu: "",
        role: "",
        report_to: [],
        discount_rate: 0,
        authority: [],
        no_authority: [],
        city_vendor:[],
        is_external: false,
        company_id: null,
        active: null,
      },
      formLabelWidth: "120px",
      dialogFormLoading: false,
      insert_status_code: "",
      remove_status_code: "",
      update_status_code: "",
      userTableLoading: false,
      distinct_bu_list: [],
      filter_format_list: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      buFilterList: [],
      rules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "change" },
        ],
        bu: [{ required: true, message: "请选择业务部门", trigger: "change" }],
        role: [{ required: true, message: "请选择职位", trigger: "change" }],
      },
      nameKeyword: "",
      nameKeywordVisible: false,
      nameKeywordHighlight: false,
      buArray: [],
      buArrayVisible: false,
      buArrayHighlight: false,
      updated_by: "",
      updated_at: "",
      city_vendor_options:[],
      company_options: [],
      companyArray: [],
      companyArrayHighlight: false,
      rules_external: {
        email: [{ required: true, message: "请输入邮箱地址", trigger: "change" }],
        company_id: [{ required: true, message: "请选择所属公司", trigger: "change" }],
        password: [{ required: true, message: "请输入初始密码", trigger: "change" }],
      },
    };
  },
  components: {
    head_page,
    head_menu,
  },
  watch: {
    "form_add.role": {
      handler(newVal, oldVal) {
        let itemToBeRemoved = [4,5,6,10,13,14]
        let authority_list = []
        for (let i in this.authority_options){
          authority_list.push(this.authority_options[i]['id'])
        }
        let city_code = authority_list.filter(  (x) => !itemToBeRemoved.includes(x)  )
        switch(newVal){
          // Sales
          case 2:
             this.form_add.authority = city_code

              this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(1), 1)
              this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(2), 1)
              this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(3), 1)
              this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(11), 1)
              this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(12), 1)

            break
          //SalesTeamHead
          case 3:
            city_code.push(6)
            this.form_add.authority = city_code
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(1), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(2), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(3), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(11), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(12), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(6), 1)
            break
          //SalesDirector
          case 4:
            city_code.push(4,5,6)
            this.form_add.authority = city_code
            this.form_add.authority = city_code
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(1), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(2), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(3), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(11), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(12), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(4), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(5), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(6), 1)
            break
          //Marketing
          case 5:
            city_code.push(4,5,6)
            this.form_add.authority = city_code
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(1), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(2), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(3), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(11), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(12), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(4), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(5), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(6), 1)
            break
          //Management
          case 6:
            city_code.push(4,5,6)
            this.form_add.authority = city_code
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(1), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(2), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(3), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(11), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(12), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(4), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(5), 1)
            this.form_add.no_authority.splice(this.form_add.no_authority.indexOf(6), 1)
            break
        }
      },
      immediate: true}
  },
  created() {
    this.loading = true;
    if (JSON.parse(sessionStorage.getItem("User")) != null) {
      this.user = JSON.parse(sessionStorage.getItem("User"))
        .split(".")[0]
        .toUpperCase();
    }
    // if (JSON.parse(sessionStorage.getItem("UserAuthority")) != null) {
    //   let userAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
    //   this.is_national = userAuthority.is_national;
    //   this.view_nanjing = userAuthority.view_nanjing;
    //   this.view_wuhan = userAuthority.view_wuhan;
    //   this.view_shenzhen = userAuthority.view_shenzhen;
    //   this.view_chongqing = userAuthority.view_chongqing;
    //   this.getChosenCity();

    // }
    // window.addEventListener("resize", this.resizeHandler);
  },
  mounted() {
      this.$refs.head_page.update_user_name();
      this.lang = JSON.parse(sessionStorage.getItem("lang"));
      this.$i18n.locale = this.lang;
      this.getUserList();
      this.getCompanyList();
  },
  methods: {
    getChosenCity() {
      if (this.is_national) {
        this.chosen_city = "Global";
      } else if (this.is_national == false && this.view_nanjing == true) {
        this.chosen_city = "Nanjing";
      } else if (this.is_national == false && this.view_wuhan == true) {
        this.chosen_city = "Wuhan";
      } else if (this.is_national == false && this.view_shenzhen == true) {
        this.chosen_city = "Shenzhen";
      } else if (this.is_national == false && this.view_chongqing == true) {
        this.chosen_city = "Chongqing";
      }
    },
    handleClick(row) {
    },

    goBack() {
      this.$router.back();
    },
    goHome: function (event) {
      this.$router.push({
        path: "/choose_city",
      });
      let lang = JSON.parse(sessionStorage.getItem("lang"));
      let user = JSON.parse(sessionStorage.getItem("User"));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      sessionStorage.clear();
      sessionStorage.setItem("lang", JSON.stringify(lang));
      sessionStorage.setItem("User", JSON.stringify(user));
      sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
    },
    resizeHandler() {
      const width = this.$refs.doughnutDiv.$el.clientWidth;
      if (width > 600) {
        this.doughntPadding = (width - 600) / 2;
        this.doughntHeight = 400;
        this.doughnutBoxWidth = 40;
        this.doughnutPosition = "right";
      } else {
        this.doughntPadding = 0;
        this.doughntHeight = width > 400 ? 400 : width;
        this.doughnutBoxWidth = 30;
        this.doughnutPosition = "bottom";
      }
      if (width < 350) {
        this.dataPickerWidth = width;
      } else {
        this.dataPickerWidth = 350;
      }
      if (screen.width < 646) {
        this.isRangeDatePicker = false;
        this.dataPickerWidth = (screen.width - 70) / 2;
      } else {
        this.isRangeDatePicker = true;
      }
      this.proposal_top_options.dataLabels.enabled = width >= 800;
      this.proposal_top_options = { ...this.proposal_top_options };
    },
    async clickEdit(email) {
        await this.getAuthorityList();
        this.getCompanyList();
        this.getRoleList();
        this.getCityVendorList();
        this.getReportToList(email);
        this.getUserDetail(email);

        this.editDialogFormVisible = true;
    },
    updateConfirm() {
      
      this.$confirm(
        this.$t("message.confirm_operation"),
        this.$t("message.info"),
        {
          confirmButtonText: this.$t("message.Confirm"),
          cancelButtonText: this.$t("message.Cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.updateUser();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.Cancel"),
          });
        });
    },
    updateUser() {
      let api_url = _global.serverSrc + "/update_bam_user/";
      var _self = this;
      var new_arr = []
      for (let i = 0;i<this.authority_options.length;i++){
       if(this.form_edit.no_authority.indexOf(this.authority_options[i].id) == -1) {
         new_arr.push(this.authority_options[i].id)
       }
      }
      
      this.form_edit.authority = new_arr
      if(this.canCreateCrossCity == 'Yes'){
        this.form_edit.authority.push(15)
      } else {
        if(this.form_edit.no_authority.indexOf(15) != -1) {
          this.form_edit.authority.splice(this.form_edit.no_authority.indexOf(15), 1)
        }
      }

      let obj = {
        form: {
          ..._self.form_edit,
          is_external: _self.form_edit.is_external
        },
        email: JSON.parse(sessionStorage.getItem('User'))
      };

      this.$axios
          .post(api_url, obj)
          .then((response) => {
              _self.update_status_code = response.data.status_code;
          _self.editDialogFormVisible = false;
          _self.$message({
            message: this.update_status_code,
          });
          _self.getUserList();
        })
        .catch((e) => {
        });
    },
    clickRemove(email) {
      this.$confirm(
        this.$t("message.confirm_operation"),
        this.$t("message.info"),
        {
          confirmButtonText: this.$t("message.Confirm"),
          cancelButtonText: this.$t("message.Cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.removeUser(email);
        })
        .catch(() => {});
    },
    removeUser(email) {
      let api_url = _global.serverSrc + "/remove_bam_user/";
      var _self = this;

      let obj = {
        email: JSON.parse(sessionStorage.getItem('User')),
        delete_user_email: email,
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.remove_status_code = response.data.status_code;
          _self.$message({
            message: _self.remove_status_code,
          });
          _self.getUserList();
        })
        .catch((e) => {
        });
    },
    clickAdd() {
      (this.form_add = {
        email: "@jcdecaux.com",
        name: "",
        bu: "",
        role: "",
        report_to: [],
        discount_rate: 100,
        authority: [],
        no_authority:[]

      }),
      this.getBuList();
      this.getRoleList();
      this.getAuthorityList();
      this.getReportToList(JSON.parse(sessionStorage.getItem("User")));
      this.getCityVendorList();

      
      
      
        (this.dialogFormLoading = false);
        
      this.addDialogFormVisible = true;
    },
    clickAddExternalUser(){
      this.form_add_external = {
        email: "",
        name: "",
        bu: "",
        company_id: "",
        password: "",
        authority: [],
        no_authority: [],
        city_vendor: [],
      };
      this.getCompanyList();
      this.getAuthorityExternalList();
      this.getCityVendorList();
      this.dialogFormLoading = false;
      this.addDialogAddFormVisible = true;
    },
    getCompanyList() {
      let api_url = _global.serverSrc + "/get_company_list/";
      var _self = this;
      let obj = { email: JSON.parse(sessionStorage.getItem("User")) };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.company_options = response.data.company_list;
        })
        .catch((e) => {});
    },
    toggleExternalUserStatus(email, currentActive) {
      const newActive = currentActive === 1 ? 0 : 1;
      const actionMsg = newActive === 0 ? "停用" : "启用";
      this.$confirm(`确认${actionMsg}该用户？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let api_url = _global.serverSrc + "/update_bam_user/";
          let obj = {
            form: { email: email, active: newActive },
            email: JSON.parse(sessionStorage.getItem("User")),
          };
          this.$axios
            .post(api_url, obj)
            .then(() => {
              this.$message({ message: `${actionMsg}成功` });
              this.getUserList();
            })
            .catch((e) => {});
        })
        .catch(() => {});
    },
    addExternalConfirm(){
      this.$confirm(
        this.$t("message.confirm_operation"),
        this.$t("message.info"),
        {
          confirmButtonText: this.$t("message.Confirm"),
          cancelButtonText: this.$t("message.Cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.addExternalUser();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.Cancel"),
          });
        });
    },
    addConfirm() {
      this.$confirm(
        this.$t("message.confirm_operation"),
        this.$t("message.info"),
        {
          confirmButtonText: this.$t("message.Confirm"),
          cancelButtonText: this.$t("message.Cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.addUser();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.Cancel"),
          });
        });
    },
    getNameFromEmail(email) {
      let first_name = email.split("@")[0].split(".")[0];
      let last_name = email.split("@")[0].split(".")[1];

      let name = first_name + " " + last_name;

      return name;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addConfirm();
        } else {
          return false;
        }
      });
    },
    addExternalUser(){
      let api_url = _global.serverSrc + "/add_bam_external_user/";
      var _self = this;
      if(this.form_add_external.email == ''){
        this.$notify.error({ title: 'Error', message: "Please input email address" });
        return;
      }
      if(!this.form_add_external.company_id){
        this.$notify.error({ title: 'Error', message: "Please select a company" });
        return;
      }
      if(!this.form_add_external.password){
        this.$notify.error({ title: 'Error', message: "Please input initial password" });
        return;
      }

      this.form_add_external.name = this.form_add_external.email.split("@")[0];

      var new_arr = [];
      for (let i = 0; i < this.authority_options.length; i++){
        if(this.form_add_external.no_authority.indexOf(this.authority_options[i].id) == -1) {
          new_arr.push(this.authority_options[i].id);
        }
      }
      this.form_add_external.authority = new_arr;

      let obj = {
        form: _self.form_add_external,
        email: JSON.parse(sessionStorage.getItem('User'))
      };

      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.insert_status_code = response.data.status_code;
          if(_self.insert_status_code == "email_exists"){
            this.$notify.error({ title: 'Error', message: "Email exists" });
          } else {
            _self.addDialogAddFormVisible = false;
            _self.$message({ message: _self.insert_status_code });
            _self.getUserList();
          }
        })
        .catch((e) => {});
    },
    addUser() {
      let api_url = _global.serverSrc + "/add_bam_user/";
      var _self = this;

      this.form_add.name = this.getNameFromEmail(this.form_add.email);
      
      let obj = {
        form: _self.form_add,
        email: JSON.parse(sessionStorage.getItem('User'))
      };
      var new_arr = []
      for (let i = 0;i<this.authority_options.length;i++){
       if(this.form_add.no_authority.indexOf(this.authority_options[i].id) == -1) {
        
         new_arr.push(this.authority_options[i].id)
       } 
      }
      
      this.form_add.authority = new_arr
      if(this.canCreateCrossCity == 'Yes'){
        this.form_add.authority.push(15)
      } else {
        if(this.form_add.no_authority.indexOf(15) != -1) {
          this.form_add.authority.splice(this.form_add.no_authority.indexOf(15), 1)
        }
      }
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.insert_status_code = response.data.status_code;
          _self.addDialogFormVisible = false;
          _self.$message({
            message: this.insert_status_code,
          });
          _self.getUserList();
        })
        .catch((e) => {
        });
     
    },
    getUserList() {
        let api_url = _global.serverSrc + "/get_bam_user_list/";
        var _self = this;

        let obj = {
            email: JSON.parse(sessionStorage.getItem("User")),
            nameKeyword: this.nameKeyword,
            currentPage: this.currentPage,
            pageSize: this.pageSize,
            companyFilterList: this.companyArray,
            nameKeyword: this.nameKeyword,
            user_type: "external",  // 只获取外部用户
        };
        this.userTableLoading = true;

      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.totalSize = response.data.total_size;
          _self.user_list = response.data.user_list;
          _self.userTableLoading = false;
        })
        .catch((e) => {
        });
    },
    getUserDetail(email) {
      let api_url = _global.serverSrc + "/get_user_detail/";
      var _self = this;
      this.dialogFormLoading = true;

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
        target:email
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.form_edit.email = response.data.user_detail.email;
          _self.form_edit.name = response.data.user_detail.name;
          _self.form_edit.bu = response.data.user_detail.bu;
          _self.form_edit.role = response.data.user_detail.role;
          _self.form_edit.discount_rate = response.data.user_detail.discount_rate;

          _self.form_edit.report_to = response.data.user_detail.report_to;
        

          
          
          _self.form_edit.authority = response.data.user_detail.authority;
          _self.form_edit.no_authority = []
          if(_self.form_edit.authority.indexOf(15) == -1){
            _self.canCreateCrossCity = 'No'
          } else {
            _self.canCreateCrossCity = 'Yes'
          }
          for (let i = 0;i < _self.authority_options.length;i++){
            if(_self.form_edit.authority.indexOf(_self.authority_options[i].id) == -1){
              _self.form_edit.no_authority.push(_self.authority_options[i].id)
            }
          }

          //_self.authority_options.splice( _self.authority_options.findIndex(item => item.id == 15),1)

          
          this.updated_by = response.data.user_detail.updated_by
          this.updated_at = response.data.user_detail.updated_at
          _self.dialogFormLoading = false;

          _self.form_edit.city_vendor = response.data.user_detail.city_vendor;
          _self.form_edit.is_external = response.data.user_detail.is_external || false;
          _self.form_edit.company_id = response.data.user_detail.company_id || null;
          _self.form_edit.active = response.data.user_detail.active;
        })
        .catch((e) => {
        });
    },
    getBuList() {
      let api_url = _global.serverSrc + "/get_bu_list/";
      var _self = this;

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.bu_options = response.data.bu_list.bu_list;
          _self.buildFilterFormat(_self.bu_options);
        })
        .catch((e) => {
        });
    },

    getCityVendorList() {
      let api_url = _global.serverSrc + "/get_city_and_vendor_list/";
      var _self = this;

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.city_vendor_options = response.data.city_and_vendor_list;
        })
        .catch((e) => {
        });
    },
    buildFilterFormat(distinct_bu_list) {
      var filter_format_list = Array();
      for (let i = 0; i < distinct_bu_list.length; i++) {
        filter_format_list.push({
          text: distinct_bu_list[i]["name"],
          value: distinct_bu_list[i]["name"],
        });
      }
      this.filter_format_list = filter_format_list;
    },
    getRoleList() {
      let api_url = _global.serverSrc + "/get_role_list/";
      var _self = this;

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.role_options = response.data.role_list.role_list;
        })
        .catch((e) => {
        });
    },
    async getAuthorityList() {
      let api_url = _global.serverSrc + "/get_authority_list/";
      var _self = this;

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
      };

      await this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.authority_options = response.data.authority_list.authority_list;
          _self.authority_options.splice( _self.authority_options.findIndex(item => item.id == 15),1)
          
          for (let i = 0;i<_self.authority_options.length;i++){
            _self.form_add.no_authority.push(_self.authority_options[i].id)
          }
        })
        .catch((e) => {
        });
    },
    getAuthorityExternalList(){
      let api_url = _global.serverSrc + "/get_authority_list/";
      var _self = this;
      _self.authority_options = []

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
      };
      this.$axios
        .post(api_url, obj)
        .then((response) => {
          
          for (let i = 0;i<response.data.authority_list.authority_list.length;i++){
            if (response.data.authority_list.authority_list[i].name.startsWith('浏览')){
              _self.authority_options.push(response.data.authority_list.authority_list[i])
            }
            
      }
         
          for (let i = 0;i<_self.authority_options.length;i++){
            _self.form_add_external.no_authority.push(_self.authority_options[i].id)
      }
        })
        .catch((e) => {
        });

    },
    getReportToList(email) {
      let api_url = _global.serverSrc + "/get_report_to_list/";
      var _self = this;

      let obj = {
        email: JSON.parse(sessionStorage.getItem("User")),
        target:email
      };

      this.$axios
        .post(api_url, obj)
        .then((response) => {
          _self.report_to_options = response.data.report_to_list.report_to_list;
        })
        .catch((e) => {
        });
    },
    filterChange(filterObj) {
      //筛选
      if (filterObj.filterTag.length > 0) {
        this.buFilterList = filterObj.filterTag;
        this.getUserList();
        //重置
      } else {
        this.buFilterList = filterObj.filterTag;
        this.getUserList();
      }
    },
    handleSizeChange(val) {
      this.currentPage =
        (this.currentPage * this.pageSize) / val +
          ((this.currentPage * this.pageSize) % val) ==
        0
          ? 0
          : 1;
      this.pageSize = val;
      this.getUserList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserList();
    },
    nameFilterHandler() {
      this.$refs.nameKeyword.doClose();
      this.currentPage = 1;
      this.nameKeywordHighlight = true;
      this.getUserList();
    },
    nameResetHandler() {
      this.$refs.nameKeyword.doClose();
      this.nameKeyword = "";
      this.currentPage = 1;
      this.nameKeywordHighlight = false;
      this.getUserList();
    },
    companyFilterHandler() {
      this.$refs.companyArray.doClose();
      this.currentPage = 1;
      this.companyArrayHighlight = true;
      this.getUserList();
    },
    companyResetHandler() {
        this.$refs.companyArray.doClose();
        this.companyArray = [];
        this.currentPage = 1;
        this.companyArrayHighlight = false;
        this.getUserList();
    },
    changeAddDiagTransferBoxColor() {
      document
        .getElementById("add_diag_transfer")
        .getElementsByClassName(
          "el-transfer-panel__header"
        )[0].style.background = "#40aeff";
        document
        .getElementById("add_diag_transfer")
        .getElementsByClassName(
          "el-transfer-panel__body"
        )[0].style.background = "rgba(64,174,255,0.34)";
      document
        .getElementById("add_diag_transfer")
        .getElementsByClassName(
          "el-transfer-panel__header"
        )[1].style.background = "#40aeff";
      // document.getElementById("add_diag_transfer").getElementsByClassName("el-transfer-panel__header")[1].style.color = "#FFFFFF"
    },
    changeEditDiagTransferBoxColor() {
      document
        .getElementById("edit_diag_transfer")
        .getElementsByClassName(
          "el-transfer-panel__header"
        )[0].style.background = "#40aeff";
        document
        .getElementById("edit_diag_transfer")
        .getElementsByClassName(
          "el-transfer-panel__body"
        )[0].style.background = "rgba(64,174,255,0.34)";
      document
        .getElementById("edit_diag_transfer")
        .getElementsByClassName(
          "el-transfer-panel__body"
        )[1].style.background = "#F5F7FA";
      // document.getElementById("edit_diag_transfer").getElementsByClassName("el-transfer-panel__header").getElementsByClassName("el-checkbox").getElementsByClassName("el-checkbox__label").style.color = "#FFFFFF"
    },
    clickCompanyManagement() {
      this.$router.push({ path: '/companymanagement' });
    },
  },
  computed: {},
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
  },
};
</script>

<style lang="scss">
.user-table-filter {
  margin: -12px;

  .user-table-filter__content {
    padding: 10px 10px 0 10px;

    .sub-title {
      margin: 5px;
      line-height: 19px;
      font-size: 14px;
    }

    .search-input {
      margin: 5px;
      -webkit-appearance: none;
      background-color: #ffffff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: none;
      padding: 0 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 200px;
    }

    input::-webkit-input-placeholder {
      color: #dcdfe6;
    }

    .el-checkbox {
      display: block;
      margin: 0 0 10px 10px;

      .el-checkbox__label {
        margin: 0 5px;
      }
    }
  }

  .user-table-filter__bottom {
    border-top: 1px solid #ebeef5;
    padding: 13px;

    button {
      background: transparent;
      border: none;
      color: #606266;
      cursor: pointer;
      font-size: 13px;
      padding: 0 3px;
    }

    button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
</style>

<style lang="scss" scoped>
/deep/.el-table__column-filter-trigger i {
  font-weight: bold;
  font-size: 18px;
  color: BLUE;
}

.el-icon-arrow-down {
  font-weight: bold;
  font-size: 18px;
  color: BLUE;
}
</style>